import React from 'react'
import Image from 'next/image'
import { cn } from '@/lib/utils'

interface LogomarkProps {
  className?: string
  /**
   * @deprecated Kept for API compatibility; the Poonawalla mark is the same in both cases.
   */
  variant?: 'dark' | 'light'
  size?: number
}

const logoSrc = () =>
  `${process.env.NEXT_PUBLIC_BASE_PATH || ''}/brand/poonawalla-logo.png`

/**
 * Poonawalla logomark (PNG).
 */
export function Logomark({
  className,
  size = 40,
}: LogomarkProps) {
  return (
    <Image
      src={logoSrc()}
      alt="Poonawalla"
      width={size}
      height={size}
      className={cn('shrink-0 object-contain', className)}
      priority
    />
  )
}
